module.exports = __webpack_public_path__ + "static/img/manual-42.1e8bc1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-42.png
// module id = 8/60
// module chunks = 4